import { formatGoalRealYield } from "web_myplann/Goals/Helpers/formatGoalRealYield";
import { RentDrawdownMode } from "web_myplann/Goals/Types/RentDrawdownMode";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { RETIREMENT_DRAWDOWN_YEARS } from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementContext } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import type { InspirationGoalRecap } from "web_myplann/Inspiration/Types/InspirationTypes";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";

const R = Resources.Inspiration.Retirement.CreateGoalSheet;

export const useRetirementGoalRecap = (
	context: RetirementContext,
): InspirationGoalRecap => {
	const { t } = useResource();

	const money = (value: number) => formatInspirationMoney(value);

	return {
		title: t(R.title),
		description: t(R.description),
		footnote: t(R.footnote, { rate: formatGoalRealYield() }),
		continueLabel: t(R.continue),
		rows: [
			{
				label: t(R.rentLabel),
				note: t(R.rentNote, {
					income: money(context.desiredIncome),
					state: money(context.statePension),
				}),
				value: money(context.gap),
			},
			{
				label: t(R.dueDateLabel),
				note: t(R.dueDateNote, { age: context.retirementAge }),
				value: t(Resources.Goals.List.DueIn.Years, {
					count: context.yearsToRetirement,
				}),
			},
			{
				label: t(R.capitalLabel),
				note:
					context.drawdownMode === RentDrawdownMode.Perpetual
						? t(R.capitalNotePerpetual)
						: t(R.capitalNoteToZero, { years: RETIREMENT_DRAWDOWN_YEARS }),
				value: money(context.targetCapital),
				highlight: true,
				dividerBefore: true,
			},
		],
	};
};
